import { render, staticRenderFns } from "./OrderAccountTableMobile.vue?vue&type=template&id=36aeef0e&scoped=true&"
import script from "./OrderAccountTableMobile.vue?vue&type=script&lang=js&"
export * from "./OrderAccountTableMobile.vue?vue&type=script&lang=js&"
import style0 from "./OrderAccountTableMobile.vue?vue&type=style&index=0&id=36aeef0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aeef0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
